import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { Promo } from '../models/entities/promo-entity';
import { PromoPartnerFamily } from '../models/entities/promo-partner-family.entity';
import { PromoProductFamily } from '../models/entities/promo-product-family.entity';
import { PromoRequest } from '../models/dtos/promo-request';
import { PromoPartnerFamilyRequest } from '../models/dtos/promo-partner-family-request';
import { PromoProductFamilyRequest } from '../models/dtos/promo-product-family-request';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';



@Injectable({
    providedIn: 'root'
})
export class PromoService {


    constructor(
        private networkService  : LeanNetworkService,
        public userService   : UserService) {
    }

    //------------------------------------------------------------------------------------
    // Promo Types Get
    //------------------------------------------------------------------------------------
    promoTypesGet(): Promise<any[]> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = "promoType";
        return new Promise((resolve, reject) => {
            this.networkService.post('admin/getControlList', request).then(result => {
                return resolve(result.list);
            }, error => {
                reject(error);
            });
        });
    }

    promosGet(promoCode : string, name : string, progressLevel : number, startDate : Date, endDate : Date): Promise<any[]> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = promoCode;
        request.strArg2 = name ;
        request.nbrArg1 = progressLevel;
        request.dteArg1 = startDate;
        request.dteArg2 = endDate;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/admin/promosGet', request).then(result => {
                return resolve(result.promos);
            }, error => {
                reject(error);
            });
        });
    }

    promoDetailGet(promoCode : string): Promise<Promo> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = promoCode;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/admin/promoDetailGet', request).then(result => {
                return resolve(result.promo);
            }, error => {
                reject(error);
            });
        });
    }

    promoSave(promo : Promo) : Promise<Promo>{
        let request: PromoRequest = new PromoRequest(this.userService.userInfo);
        request.promo = promo;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/admin/promoSave', request).then(result => {
                let promo : Promo= result.promo;
                return resolve(promo);
            }, error => {
                reject(error);
            });
        });
    }
    
    promoValidate(promo : Promo) : Promise<Promo>{
        let request: PromoRequest = new PromoRequest(this.userService.userInfo);
        request.promo = promo;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/admin/promoValidate', request).then(result => {
                let promo : Promo= result.promo;
                return resolve(promo);
            }, error => {
                reject(error);
            });
        });
    }


    promoClose(promo : Promo) : Promise<Promo>{
        let request: PromoRequest = new PromoRequest(this.userService.userInfo);
        request.promo = promo;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/admin/promoClose', request).then(result => {
                let promo : Promo= result.promo;
                return resolve(promo);
            }, error => {
                reject(error);
            });
        });
    }

    promoPartnerFamiliesGet(code: string, name : string) : Promise<PromoPartnerFamily[]>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = code;
        request.strArg2 = name;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/admin/promoPartnerFamiliesGet', request).then(result => {
                return resolve(result.promoPartnerFamilies);
            }, error => {
                reject(error);
            });
        });
    }
   
    promoPartnerFamilyGet(code: string) : Promise<PromoPartnerFamily>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = code;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/admin/promoPartnerFamilyGet', request).then(result => {
                return resolve(result.promoPartnerFamily);
            }, error => {
                reject(error);
            });
        });
    }

    promoPartnerFamilySave(promoPartnerFamily: PromoPartnerFamily): Promise<PromoPartnerFamily> {
        let request: PromoPartnerFamilyRequest = new PromoPartnerFamilyRequest(this.userService.userInfo);
        request.promoPartnerFamily = promoPartnerFamily;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/admin/promoPartnerFamilySave', request).then(result => {
                let promoPartnerFamily : PromoPartnerFamily = result.promoPartnerFamily;
                return resolve(promoPartnerFamily);
            }, error => {
                reject(error);
            });
        });
      }




    promoProductFamiliesGet(code: string, name : string) : Promise<PromoProductFamily[]>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = code;
        request.strArg2 = name;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/admin/promoProductFamiliesGet', request).then(result => {
                return resolve(result.promoProductFamilies);
            }, error => {
                reject(error);
            });
        });
    }

    promoProductFamilyGet(code: string) : Promise<PromoProductFamily>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = code;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/admin/promoProductFamilyGet', request).then(result => {
                return resolve(result.promoProductFamily);
            }, error => {
                reject(error);
            });
        });
    }

    promoProductFamilySave(promoProductFamily: PromoProductFamily): Promise<PromoProductFamily> {
        let request: PromoProductFamilyRequest = new PromoProductFamilyRequest(this.userService.userInfo);
        request.promoProductFamily = promoProductFamily;
    
        return new Promise((resolve, reject) => {
            this.networkService.post('sales/admin/promoProductFamilySave', request).then(result => {
                let promoProductFamily : PromoProductFamily = result.promoProductFamily;
                return resolve(promoProductFamily);
            }, error => {
                reject(error);
            });
        });
    }
}
